const isOS = () => navigator.userAgent.match(/ipad|iphone/i);

export default {
  isOS,
  selectText: (target) => {
    let range;
    let selection;

    if (isOS()) {
      range = document.createRange();
      range.selectNodeContents(target);
      selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      target.setSelectionRange(0, 999999);
    } else {
      target.select();
    }
  },
  copyToClipboard: () => {
    document.execCommand('copy');
  },
};
